import React, {useState, Fragment} from 'react';
import { nuevoOActualizarRegistroPersonalizado, obtenerRegistrosPorURL, setearDatosAlStore } from 'store/actions/customAction';
import DetalleDelTarifario from 'components/nuevoTarifario/detalleDelTarifario';
import TooltipPersonalizado from 'components/tooltip/TooltipPersonalizado';
import { alertaPersonalizadaSwal } from 'servicios/AlertasPersonalizados';
import ModalDeConfirmacion from 'components/Modales/ModalDeConfirmacion';
import DatosDeEmpresa from 'components/nuevoTarifario/DatosDeEmpresa';
import AlertaDeRespuesta from 'components/AlertaDeRespuesta';
import IndicadorDeCarga from 'components/IndicadorDeCarga';
import { nombreDeAcciones } from 'constantes';
import {useDispatch} from 'react-redux';
import NuevoCanal from './NuevoCanal';

const Television = () => {
    const dispatch = useDispatch();
    const [tarifarioDeMediosTelevisivos] = useState('tarifarioDeMediosTelevisivos');
    const [datosDeRespuesta, setDatosDeRespuesta] = useState({ tipoDeAlerta: 'error', mensajeDeAlerta: '', mostrarRespuesta: false, });
    const[cargandoSolicitud, setCargandoSolicitud] = useState(false);
    const [abrirNuevoCanal, setAbrirNuevoCanal] = useState(false);
    const [steps] = useState( [{id: 0, label: 'Datos del Canal'}, {id: 1, label: "Tarifario y Disponibilidad"}, {id: 2, label: "Cobertura"}, {id: 3, label: "Datos Demográficos"}]);
    const [datosDeEmpresa, setDatosDeEmpresa] = useState({});
    const [recargarLaTabla, setRecargarLaTabla] = useState(false),
    [datosGeneralesDelTarifario, setDatosGeneralesDelTarifario] = useState({}),
    [abrirDetalleTarifario, setAbrirDetalleTarifario] = useState(false),
    [alertaDeConfirmacion, setAlertaDeConfirmacion] = useState(false);

    const [header] = useState([
        { title: 'Nombre del canal', field: 'medioDeComunicacion.nombre'},
        { title: 'No. Canal', field: 'numeroDelCanal'},
        { title: 'Acciones', field: 'accion',
        render: rowData=><div style={{minWidth: '100px'}}>
            {
                (<div>
                    <TooltipPersonalizado title="Visualizar detalle del canal" handleFunction={() => mostrarDetalleDelCanal(rowData)} icon="visibility" fontSize={30} />
                    <TooltipPersonalizado title="Eliminar canal" handleFunction={() => mostrarAlertaDeConfirmacion(rowData)} icon="delete" fontSize={30} color="red" />
                </div>)
            }
            </div>
        },
    ]);

    const mostrarAlertaDeConfirmacion = async (elemento) => {
        setDatosGeneralesDelTarifario(elemento)
        setAlertaDeConfirmacion(true)
    }

    const mostrarDetalleDelCanal = async (elemento) => {
        setCargandoSolicitud(true);

        let respuesta = await dispatch(obtenerRegistrosPorURL({ controller: tarifarioDeMediosTelevisivos, saveInStore: false, nombreDelMetodo: "listar/registros", parametro: elemento?.medioDeComunicacion?.id}));

        setCargandoSolicitud(false);

        if(respuesta?.error) return alertaPersonalizadaSwal(`${respuesta.error?.message || "No se pudo obtener la información del canal"}`);

        if(respuesta?.data?.length === 0) return alertaPersonalizadaSwal("No existen datos para mostrar");

        setDatosGeneralesDelTarifario(respuesta.data)
        setAbrirDetalleTarifario(true)
    }

    const handClose = (_, reason) => {
        if (reason === 'clickaway') {return}
        changeDataResponse('error', '', false)
    };

    const changeDataResponse = (tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta = false) => setDatosDeRespuesta({tipoDeAlerta,mensajeDeAlerta,mostrarRespuesta,})

    const addRegister= () => {
        if(!datosDeEmpresa?.ejecutivoDeMedios?.cui) return alertaPersonalizadaSwal("Debe completar los datos Contacto de medios para agregar canales", "", "warning")
        setAbrirNuevoCanal(true);
    }

    const cerrarNuevoCanal= (recargar = false) => {
        dispatch(setearDatosAlStore({ dispatchAction : nombreDeAcciones.LIMPIAR_TODO_EL_REDUCER}));
        setAbrirNuevoCanal(false)
        setRecargarLaTabla(recargar)
    };

    const cerrarDetalleDelTarifario = () => setAbrirDetalleTarifario(false)

    const accionDeAlertaDeConfirmacion = async () => {
        setAlertaDeConfirmacion(false);
        setCargandoSolicitud(true);
        changeDataResponse('error', "")

        const data = { controller: tarifarioDeMediosTelevisivos, action: 'deshabilitar', data: {}, nombreDelMetodo: `deshabilitar/${datosGeneralesDelTarifario?.medioDeComunicacion?.id}` };
        const respuesta = await dispatch(nuevoOActualizarRegistroPersonalizado(data));
        setCargandoSolicitud(false);
        if(respuesta?.error) return alertaPersonalizadaSwal(respuesta.error?.message || "", "", '');
        alertaPersonalizadaSwal(respuesta?.data || "Registro eliminado correctamente", "", 'success');
        setRecargarLaTabla(true)
    }

    const cerrarAlertaDeConfirmacion = () => setAlertaDeConfirmacion(false);

    const recargarPaginaDelMedio = () => {
        // mostrarDetalleDelCanal()
    }

    const { tipoDeAlerta, mensajeDeAlerta, mostrarRespuesta} = datosDeRespuesta;

    return (
        <Fragment>
            {cargandoSolicitud ? <IndicadorDeCarga open={cargandoSolicitud} /> : '' }
            <AlertaDeRespuesta type={tipoDeAlerta} content={mensajeDeAlerta} open={mostrarRespuesta} handClose={handClose}/>

            <DatosDeEmpresa
                header={header}
                tituloGeneral={"FORMULARIO DE REGISTRO TELEVISIÓN"}
                icon={"television"}
                tituloDeTabla={"LISTADO DE CANALES REGISTRADOS"}
                addRegister={addRegister}
                nombreToolTip={"AGREGAR CANAL"}
                iconTabla={"television"}
                setDatosDeEmpresa={setDatosDeEmpresa}
                controladorTarifario={"tarifarioDeMediosTelevisivos"}
                recargarLaTabla={recargarLaTabla}
                datosDeEmpresa={datosDeEmpresa}
                setRecargarLaTabla={setRecargarLaTabla}
                tipoMedio="television"
            />

            {abrirNuevoCanal && (
                <NuevoCanal
                    openFullScreenDialog={abrirNuevoCanal}
                    handleClose={cerrarNuevoCanal}
                    title={"Formulario para agregar nuevo canal"}
                    steps={steps}
                    datosDeEmpresa={datosDeEmpresa}
                />
            )}
            {abrirDetalleTarifario && (
                <DetalleDelTarifario
                    openFullScreenDialog={abrirDetalleTarifario}
                    handleClose={cerrarDetalleDelTarifario}
                    title={'Detalle del canal registrado'}
                    datosGeneralesDelTarifario={datosGeneralesDelTarifario}
                    tipoDelMedio={"television"}
                    mostrarDetalleDelCanal={mostrarDetalleDelCanal}
                />
            )}
            {alertaDeConfirmacion && (
                <ModalDeConfirmacion
                    title={`¿Está seguro de eliminar el canal ${datosGeneralesDelTarifario?.medioDeComunicacion?.nombre || ""}?`} message={"No podrá revertir esta acción"}
                    open={alertaDeConfirmacion} closeModal={cerrarAlertaDeConfirmacion} titleButton={"Sí, estoy seguro"}
                    actionAdd={accionDeAlertaDeConfirmacion}
                />
            )}
        </Fragment>
    );
}

export default Television;